<template>
  <div :class="mhClass">
    <b-form-group
      class="my-0"
      :label="label || table[field].label"
      label-size="sm"
      label-class="mb-0"
      :label-for="field"
    >
      <b-input-group size="sm">
        <b-form-input
          size="sm"
          :class="
            table[field].type == 'float' || table[field].type == 'double'
              ? 'text-right'
              : ''
          "
          :id="field"
          :name="field"
          :readonly="readonly"
          :state="table[field].error ? false : null"
          v-model="str"
          :debounce="debounce"
          :required="required"
          @update="change"
          @keyup="keyup"
        ></b-form-input>

        <div :id="'ac' + _uid" class="autocomplete">
          <div v-if="ac.length > 0">
            <b-list-group class="shadow">
              <b-list-group-item
                v-for="(item, index) in ac"
                :key="index"
                :active="index == activeAc"
                :data="index"
                :variant="item.history ? 'info' : ''"
              >
                <span v-if="item.icon" class="pr-2">
                  <b-icon :icon="item.icon"></b-icon>
                </span>
                <span v-html="item.highlighted"></span>
                <span v-if="item.history">
                  <b-icon-clock-history
                    class="float-right"
                  ></b-icon-clock-history>
                </span>
              </b-list-group-item>
            </b-list-group>
          </div>
        </div>

        <b-input-group-append is-text v-if="append !== null">{{
          append
        }}</b-input-group-append>
      </b-input-group>

      <b-form-text v-if="table[field].error">
        {{ table[field].error }}
      </b-form-text>
    </b-form-group>
  </div>
</template>

<script>
import axios from "axios";
import qs from "querystring";
export default {
  name: "mh-select",
  props: {
    name: String,
    mhClass: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    debounce: {
      type: [Number, String],
      default: 200,
    },
    field: String,
    readonly: {
      type: Boolean,
      default: false,
    },
    table: Object,
    append: {
      type: String,
      default: null,
    },
    inputClass: String,
    label: String,
    value: [String, Number],
    rows: {
      type: [String, Number],
      default: 1,
    },
    autocomplete: {
      type: Object,
      default: () => {
        return { field: null, api: null };
      },
    },
  },
  data() {
    return {
      ac: [],
      apiInstance: null,
      activeAc: -1,
      str: "",
    };
  },
  created() {
    this.apiInstance = axios.create({
      baseURL: this.autocomplete.api || this.$store.getters.url + "",
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
    });
    let token = localStorage.getItem("vue-token");
    if (token) {
      this.apiInstance.defaults.headers.common["Authorization"] = "Bearer " + token;
    }
    if (
      this.table &&
      this.table[this.field].type == "date" &&
      this.table[this.field].value == "0000-00-00"
    ) {
      this.table[this.field].value = null;
    }
  },
  mounted() {
    const el = document.querySelector("#ac" + this._uid);
    if (el == null) {
      return;
    }
    document.addEventListener(
      "mousedown",
      (e) => {
        if (el.contains(e.target)) {
          const id = e.target.closest(".list-group-item").getAttribute("data");
          this.table[this.field].value = this.ac[id].id;
          this.str = this.ac[id].value;
          this.ac = [];
          this.activeAc = -1;
          e.preventDefault();
          document.getElementById(this.field).focus();
          this.enter();
        } else {
          this.blur();
        }
      },
      true
    );
  },

  methods: {
    blur() {
      this.ac = [];
      this.activeAc = -1;
    },
    enter() {
      this.$emit("change");
    },
    change() {
      if (this.autocomplete.field) {
        this.autocomplete.value = this.str; //table[this.field].value;

        this.apiInstance
          .post("/ac", qs.stringify(this.autocomplete))
          .then((response) => {
            this.ac = response.data;
            //this.searchHistory(this.autocomplete.value);
            if (this.activeAc >= this.ac.length) {
              this.activeAc = 0;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      //this.$emit("change");
    },
    keyup(e) {
      if (e.key == "Enter") {
        this.blur();
        this.enter();
        return;
      }

      if (this.autocomplete.field) {
        if (this.ac.length > 0) {
          switch (e.key) {
            case "ArrowDown":
              this.activeAc++;
              if (this.activeAc >= this.ac.length) {
                this.activeAc = 0;
              }
              this.str = this.ac[this.activeAc].value.trim();
              this.table[this.field].value = this.ac[this.activeAc].id;
              //this.$emit("change");

              break;
            case "ArrowUp":
              this.activeAc--;
              if (this.activeAc < 0) {
                this.activeAc = this.ac.length - 1;
              }
              this.str = this.ac[this.activeAc].value.trim();
              this.table[this.field].value = this.ac[this.activeAc].id;
              //this.$emit("change");

              break;
            case "Enter":
              this.str = this.ac[this.activeAc].value.trim();
              this.table[this.field].value = this.ac[this.activeAc].id;
              this.ac = [];

              break;
            case "Tab":
            case "Escape":
              this.ac = [];
              break;
            case "ArrowLeft":
            case "ArrowRight":
              break;
          }
        }
      }
    },

    searchHistory(str) {
      if (str.trim() == "") return;
      let history = JSON.parse(
        localStorage.getItem("history_" + this.autocomplete.idHistory)
      );
      if (history !== null) {
        for (let i = 0; i < history.length; i++) {
          if (history[i][0].toLowerCase().indexOf(str.toLowerCase()) !== -1) {
            this.ac.unshift({
              value: history[i][0],
              highlighted: history[i][0],
              history: true,
            });
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list-group-item {
  border-bottom: none;
  padding: 5px 10px;
  font-size: 14px;
  &:hover {
    background-color: #ff9933;
    cursor: pointer;
  }
}
.autocomplete {
  z-index: 100;
  position: absolute;
  top: 30px;
  padding-left: 0 !important;
  margin: 0;
  background-color: #e9e9e9;
  display: inline-block;
  ul {
    list-style-type: none;
  }
}
.autocomplete-items {
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  /*position the autocomplete items to be the same width as the container:*/
  top: 100%;
  left: 0;
  right: 0;
}
.autocomplete-items div {
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  border-bottom: 1px solid #d4d4d4;
}
.autocomplete-items div:hover {
  /*when hovering an item:*/
  background-color: #e9e9e9;
}
.autocomplete-active {
  /*when navigating through the items using the arrow keys:*/
  background-color: DodgerBlue !important;
  color: #ffffff;
}
</style>